export default [
  {
    path: '/sn',
    name: 'sn',
    component: r => require(['views/layout/Main'], r),
    redirect: '/sn/list',
    children: [
      {
        path: 'list',
        name: 'sn-list',
        component: r => require(['views/sn/Main'], r)
      },
      {
        path: 'form',
        name: 'sn-form',
        component: r => require(['views/sn/children/Form'], r)
      },
      {
        path: 'tools',
        name: 'sn-tools',
        component: r => require(['views/sn/tools'], r)
      }
    ]
  }
]
